import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import { getApi } from "@api/apiPath";
import { axiosClient } from "@api/clients.ts";
import type { IMemberProfileStatisticsEndpoint } from "@api/system/memberProfileStatistics/types";
import type { IApiResponse } from "@/api";

const { key, getPath } = getApi("system.memberProfileStatistics.get");

const getMemberProfileStatistics: Fetcher<
  IApiResponse<IMemberProfileStatisticsEndpoint>
> = (params) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetMemberProfileStatistics = createQuery({
  queryKey: [key],
  fetcher: getMemberProfileStatistics,
});
